import { render, staticRenderFns } from "./NewUniRequest.vue?vue&type=template&id=0e6ab29e&"
import script from "./NewUniRequest.vue?vue&type=script&lang=js&"
export * from "./NewUniRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewUniRequest.vue?vue&type=style&index=0&id=0e6ab29e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports